import { render, staticRenderFns } from "./RequestPriority.vue?vue&type=template&id=1ca8ee87&"
import script from "./RequestPriority.vue?vue&type=script&lang=js&"
export * from "./RequestPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QSelect,QIcon} from 'quasar'
component.options.components = Object.assign({QItem,QSelect,QIcon}, component.options.components || {})
